import React from 'react'
import Layout from '../components/template/Layout'
import Banner from '../components/kyc/Banner'
import Content from '../components/kyc/Content'

export default class extends React.Component{
    render() {
      return(
        <Layout>
          {/* <Banner/> */}
          <Content/>
        </Layout>
      )
    }
}

// export default () => (
//   <Layout>
//         <div className="bg-u-dark">
//             <div className="containers ">
//             </div>
//         </div>
//         <div className="container">
//                     <div className="row justify-content-md-center">
//                     <iframe height='680px' width='100%' frameborder='0' allowTransparency='true' scrolling='auto' src='https://creator.zohopublic.com/admin_unified/unified-kyc/form-embed/Unified_KYC/8PymXAntV72V00eVrDK9j9KsZVuxJzQyzrkSGV1jUW7M4ymATvdrMBfnmqyNJqAnW27Q156dH7Fep9saEMjBkDTEJWQYMbQXh33m'></iframe>
//                     </div>
//                     </div>

// <style jsx>{`
//         .container {
//             display: block;
//             text-align: center;
//             width: 30%;
//             margin-bottom: 150px
//         }
//         .containers {
//             padding-top: 50px;
//             display: block;
//             text-align: center;
//             width: 30%;
//             margin-bottom: 15px
//         }
//         @media only screen and (max-width: 600px) {
//             .container {
//             display: block;
//             text-align: center;
//             width: 100%;
//             margin-bottom: 150px
//         }
//         .containers {
//             padding-top: 50px;
//             display: block;
//             text-align: center;
//             width: 100%;
//             margin-bottom: 15px
//         }
//           }
//       `}</style>
//   </Layout>
// )




// WEBPACK FOOTER //
// pages/kyc.js